import routes from '../../constants/routes';
import risk from '../../constants/risk';
import {
  postUserProvisionHighRisk,
  postUserProvisionLowRisk
} from '../../apiCalls/twistle/twistle';

export default (
  { hasSymptoms, isTempUnderThreshhold, hasCriticalSymptomes, temp },
  assignRisk
) => {
  if (hasSymptoms) {
    if (hasCriticalSymptomes || !isTempUnderThreshhold) {
      assignRisk(risk.HIGH, routes.HIGH_RISK, temp, postUserProvisionHighRisk);
    } else {
      assignRisk(risk.LOW, routes.LOW_RISK, temp, postUserProvisionLowRisk);
    }
  } else {
    if (isTempUnderThreshhold) {
      assignRisk(risk.NO, routes.APPROVED, temp);
    } else {
      assignRisk(risk.HIGH, routes.HIGH_RISK, temp, postUserProvisionHighRisk);
    }
  }
};
